import { render } from "./CompanyTabs.vue?vue&type=template&id=6a736ef8&scoped=true"
const script = {}

import "./CompanyTabs.vue?vue&type=style&index=0&id=6a736ef8&lang=scss&scoped=true"

import exportComponent from "/Users/mmessick/Sites/kiosk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a736ef8"]])

export default __exports__